var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerishable4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 4.16667H24.625C23.75 1.75 21.4583 0 18.75 0C16.0417 0 13.75 1.75 12.875 4.16667H4.16667C1.875 4.16667 0 6.04167 0 8.33333V37.5C0 39.7917 1.875 41.6667 4.16667 41.6667H33.3333C35.625 41.6667 37.5 39.7917 37.5 37.5V8.33333C37.5 6.04167 35.625 4.16667 33.3333 4.16667ZM18.75 4.16667C19.8958 4.16667 20.8333 5.10417 20.8333 6.25C20.8333 7.39583 19.8958 8.33333 18.75 8.33333C17.6042 8.33333 16.6667 7.39583 16.6667 6.25C16.6667 5.10417 17.6042 4.16667 18.75 4.16667ZM14.5833 33.3333L6.25 25L9.1875 22.0625L14.5833 27.4375L28.3125 13.7083L31.25 16.6667L14.5833 33.3333Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerishable4);
export default __webpack_public_path__ + "static/media/perishable4.0c9179b5d357689e90900a836e3d840f.svg";
export { ForwardRef as ReactComponent };